import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { FileUpload, FileUploadCreate, FileUploadFilter } from '../data/fileUpload';

export function createFileUploadService(client: AxiosInstance) {
  return createCrudService<FileUpload, FileUploadCreate, FileUploadFilter>(
    client,
    '/platform/FileUpload',
    'id',
  );
}

export type FileUploadService = CrudService<FileUpload, FileUploadCreate, FileUploadFilter>;
